import { useTranslation } from 'react-i18next';

import type { TeamMember } from '@/api/v4/team.api';
import { modalState } from '@/state/modal.state';
import type { DropdownOption } from '@/ui/dropdown/dropdown';
import { WithDropdown } from '@/ui/dropdown/dropdown';
import { MenuButton } from '@/ui/menu-button/menu-button';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import type { TeamMemberStatus } from './basic-tab-config';
import { useSetAtom } from 'jotai';

export const TeamMemberMenu = ({
  teamMember,
}: {
  teamMember: TeamMember;
  status: TeamMemberStatus;
}) => {
  const { t } = useTranslation('teams');
  const setModal = useSetAtom(modalState);

  const { hasRequiredPermission } = useUserPermissions();

  const menu: DropdownOption[] = [
    {
      label: t`removeTeamMember`,
      isVisible: hasRequiredPermission(PERMISSION.MANAGE_TEAMS),
      onClick: () => {
        setModal({
          state: 'deleteTeamMember',
          user: teamMember,
          onConfirm: () => 'removed',
        });
      },
    },
  ];

  return (
    <WithDropdown items={menu} options={{ placement: 'bottom-end' }}>
      <MenuButton />
    </WithDropdown>
  );
};
